"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "IceDrawer",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean,
    width: {
      type: Number,
      default: 400
    }
  },
  data: function data() {
    return {
      contentWidth: 0
    };
  },
  methods: {
    maskClick: function maskClick() {
      //console.log("maskClick")
      this.$emit('change', false);
    },
    stop: function stop() {}
  },
  watch: {
    value: function value() {
      if (this.value) {
        this.contentWidth = this.width;
      } else {
        this.contentWidth = 0;
      }
    }
  }
};